"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showWarnings;

var _I18n = _interopRequireDefault(require("I18n"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var THIRTY_MINUTES = 1000 * 60 * 30;
var TITLE_KEY = 'wordpress.reporting.notReady.title';

function showWarnings() {
  if (window.location.pathname.indexOf('/reports-dashboard/') !== 0) return;
  var request = window.quickFetch.getRequestStateByName('api-verify');

  if (request) {
    request.whenFinished(function (data) {
      if (data.portal.enabled_gates.indexOf('WordPress:ReportingAlert') === -1) {
        return;
      }

      if (!_I18n.default.lookup(TITLE_KEY)) return;

      if (Date.now() - data.portal.created_at < THIRTY_MINUTES) {
        _FloatingAlertStore.default.addAlert({
          titleText: _I18n.default.text(TITLE_KEY),
          sticky: true,
          type: 'warning'
        });
      }
    });
  }
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hubspot-plugin-common/static-1.186/js/showWarnings.js
// module id = 368
// module chunks = 5 6 7